import { atom } from 'recoil';
import { BrandReleaseProduct, ReleaseType } from './sneaker-release.type';

const sneakerRelease = atom({
    key: 'sneaker-release',
    default: {
        sneakerReleases: [] as BrandReleaseProduct[],
        releaseType: ReleaseType.Upcoming
    }
});

export default { sneakerRelease };
